import React from 'react';
import SoundButton from './SoundButton';
import SoundDivider from './SoundDivider';
import { View, Text } from 'react-native';
import { customCthun, customAluneth, customSkulloftheManari, customBarnes,
  customVulgarHomunculus, customHecklebot, customEvilHeclkerDalaranCrusader,
  customYogg, customFortuneTeller, customCheesemonger, customElitistSnob,
  customHipster } from './HelperFunctions';

const Specials = (props) => {

  const cardID = props.cardID
  const deviceType = props.deviceType

  const RenderSoundArrays = (props) => {
      if (cardID == 'OG_280') return <SoundButtonArray sounds={customCthun}/>
      else if (cardID == 'LOOT_108') return <SoundButtonArray sounds={customAluneth}/>
      else if (cardID == 'LOOT_420') return <SoundButtonArray sounds={customSkulloftheManari}/>
      else if (cardID == 'KAR_114') return <SoundButtonArray sounds={customBarnes}/>
      else if (cardID == 'DAL_058') return <SoundButtonArray sounds={customHecklebot}/>
      else if (cardID == 'LOOT_013') return <SoundButtonArray sounds={customVulgarHomunculus}/>
      else if (cardID == 'AT_114') return <SoundButtonArray sounds={customEvilHeclkerDalaranCrusader}/>
      else if (cardID == 'DAL_085') return <SoundButtonArray sounds={customEvilHeclkerDalaranCrusader}/>
      else if (cardID == 'DMF_004') return <SoundButtonArray sounds={customYogg}/>
      else if (cardID == 'DMF_121') return <SoundButtonArray sounds={customFortuneTeller}/>
      else if (cardID == 'SW_073') return <SoundButtonArray sounds={customCheesemonger}/>
      else if (cardID == 'REV_961') return <SoundButtonArray sounds={customElitistSnob}/>
      else if (cardID == 'ETC_103') return <SoundButtonArray sounds={customHipster('ETC_103')} fullSoundFileName={true}/>
      else if (cardID == 'TOY_916') return <SoundButtonArray sounds={customHipster('TOY_916')} fullSoundFileName={true}/>
      else return (<></>)
  }

  const SoundButtonArray = (props) => {
    return (
      <>
        <View style={{flexDirection: 'row', paddingBottom: 8}}>
            <Text style={{paddingTop: 4, alignSelf: 'flex-start', fontWeight: 'bold', width: "15%", fontSize: deviceType == 'mobile' ? 10.5 : 14}}>Special</Text>
          <View style={{flexDirection: 'row', flexWrap: 'wrap', width: "85%"}}>
            {props.sounds.map(sound => (
              <SoundButton title={sound[0]} cardID={cardID} sound={props.fullSoundFileName ? sound[1] : cardID + '_' + sound[1]} deviceType={deviceType}/>
            ))}
          </View>
        </View>
        <SoundDivider />
      </>
    )
  }

  return (
    <View style={{alignSelf: 'flex-start', width: "100%"}}>
      <RenderSoundArrays/>
    </View>
  )
}

export default Specials
